// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
// } from "@mui/material";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Navigate, useLocation, useNavigate } from "react-router-dom";
// import HOST_URL from "../../../utils/Url";
// import Autocomplete from "@mui/material/Autocomplete";
// import { useTranslation } from "react-i18next";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { toast, ToastContainer } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import { CircularProgress } from "@mui/material";
// import { useRef } from "react";
// type Props = {};

// const CityMasterEdit = (props: Props) => {

//   const { t } = useTranslation();
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const submitTimeoutRef = useRef<NodeJS.Timeout | null>(null);
//   const location = useLocation();
//   console.log("location", location.state);

//   const [option, setOption] = useState([{ value: "-1", label: t("text.SelectStateName") }]);
//   let navigate = useNavigate();


//   useEffect(() => {
//     getStateZone();
//   }, []);

//   const getStateZone = () => {
//     const collectData = {
//       state_id: -1,
//       country_id: -1
//     };
//     axios
//       .post(HOST_URL.HOST_URL2 + `State/GetStateMaster`, collectData)
//       .then((res) => {
//         const arr = [];
//         // console.log("result" + JSON.stringify(res.data.data));
//         for (let index = 0; index < res.data.data.length; index++) {
//           arr.push({
//             label: res.data.data[index]["state_name"],
//             value: res.data.data[index]["state_id"],
//           });
//         }
//         setOption(arr);
//       });
//   };
//   const [toaster, setToaster] = useState(false);

//   const validationSchema = Yup.object({
//     state_id: Yup.string().test(
//       "required",
//       t("text.reqstateName"),
//       function (value: any) {
//         return value && value.trim() !== "";
//       }
//     ),
//     city_name: Yup.string().test(
//       "required",
//       t("text.reqdistrictName"),
//       function (value: any) {
//         return value && value.trim() !== "";
//       }
//     ),
//   });

//   const formik = useFormik({
//     initialValues: {
//       city_id: location.state.city_id,
//       city_name: location.state.city_name,

//       state_id: location.state.state_id,

//       city_shortname: location.state.city_shortname,
//       stateName: location.state.stateName,
//       user_id: location.state.user_id,
//       inst_ID: location.state.inst_ID,
//       allowedto: location.state.allowedto,

//     },
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       // Clear any existing timeout
//       if (submitTimeoutRef.current) {
//         clearTimeout(submitTimeoutRef.current);
//       }

//       // If already submitting, show message and return
//       if (isSubmitting) {
//         toast.info(t("text.requestInProgress"));
//         return;
//       }

//       setIsSubmitting(true)


//       // Handle form submission
//       try {
//         const response = await axios.post(HOST_URL.HOST_URL2 + `District/AddUpdateDistrictMaster`,
//           values
//         );
//         if (response.data.isSuccess) {
//           setToaster(false);
//           toast.success(response.data.mesg);
//           navigate("/master/CityMaster");
//         } else {
//           setToaster(true);
//           toast.error(response.data.mesg);
//         }
//       } catch (error: any) {
//         if (error.response && error.response.status === 429) {
//           toast.error(t("text.tooManyRequests"));
//         } else {
//           toast.error(t("text.somethingWentWrong"));
//         }
//         setToaster(true);
//       } finally {
//         // Set a timeout to reset isSubmitting after 2 seconds
//         submitTimeoutRef.current = setTimeout(() => {
//           setIsSubmitting(false);
//         }, 2000);
//       }
//     }
//   });
//   // Add cleanup effect
//   React.useEffect(() => {
//     return () => {
//       if (submitTimeoutRef.current) {
//         clearTimeout(submitTimeoutRef.current);
//       }
//     };
//   }, []);

//   const requiredFields = ["state_id", "city_name"];

//   const back = useNavigate();

//   return (
//     <div>
//       <div
//         style={{
//           padding: "-5px 5px",
//           backgroundColor: "#ffffff",
//           borderRadius: "5px",
//           marginTop: "5px",
//           border: ".5px solid #FF7722",
//         }}
//       >
//         <CardContent>
//           <Typography
//             variant="h5"
//             textAlign="center"
//             style={{ fontSize: "18px", fontWeight: 500 }}
//           >
//             {t("text.EditDistrictMaster")}
//           </Typography>

//           <Grid item sm={4} xs={12}>
//             <Typography style={{ marginTop: "-75px" }}>
//               <Button
//                 type="submit"
//                 onClick={() => back(-1)}
//                 variant="contained"
//                 style={{
//                   marginBottom: 15,
//                   marginTop: "45px",
//                   backgroundColor: `var(--header-background)`,
//                   width: 20,
//                 }}
//                 disabled={isSubmitting}
//               >
//                 <ArrowBackSharpIcon />
//               </Button>
//             </Typography>
//           </Grid>
//           <Divider />
//           <br />
//           <form onSubmit={formik.handleSubmit}>
//             <ToastContainer />
//             <Grid item xs={12} container spacing={2}>
//               <Grid xs={12} sm={4} item>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={option}
//                   fullWidth
//                   size="small"
//                   disabled={isSubmitting}
//                   value={option.find(opt => opt.value === formik.values.state_id) || null}
//                   onChange={(event, newValue) => {
//                     console.log(newValue?.value);
//                     formik.setFieldValue("state_id", newValue?.value);
//                     formik.setFieldTouched("state_id", true);
//                   }}
//                   // value={}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.SelectStateName")} {""}
//                           {requiredFields.includes("state_id") && (
//                             <span
//                               style={{
//                                 color: formik.values.state_id
//                                   ? "green"
//                                   : "red",
//                               }}
//                             >
//                               *
//                             </span>
//                           )}
//                         </span>
//                       }
//                     />
//                   )}
//                 />
//                 {formik.errors.state_id ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.state_id)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid xs={12} sm={4} item>
//                 <TextField
//                   label={
//                     <span>
//                       {t("text.EnterDistrictName")}{" "}
//                       {requiredFields.includes("city_name") && (
//                         <span
//                           style={{
//                             color: formik.values.city_name ? "green" : "red",
//                           }}
//                         >
//                           *
//                         </span>
//                       )}
//                     </span>
//                   }
//                   value={formik.values.city_name}
//                   name="city_name"
//                   id="city_name"
//                   placeholder={t("text.EnterDistrictName")}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   inputProps={{ maxLength: 30 }}
//                   disabled={isSubmitting}
//                 />
//                 {formik.touched.city_name && formik.errors.city_name ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.city_name)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <TextField
//                   id="city_shortname"
//                   name="city_shortname"
//                   label={t("text.EnterShortName")}
//                   value={formik.values.city_shortname}
//                   placeholder={t("text.EnterShortName")}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   inputProps={{ maxLength: 10 }}
//                   disabled={isSubmitting}
//                 />
//               </Grid>



//               <Grid item lg={6} sm={6} xs={12}>
//                 <Grid>
//                   <Button
//                     type="submit"
//                     fullWidth
//                     style={{
//                       backgroundColor: `var(--header-background)`,
//                       color: "white",
//                       marginTop: "10px",
//                     }}
//                     disabled={isSubmitting}
//                     startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
//                   >
//                     {isSubmitting ? t("text.submitting") : t("text.update")}
//                   </Button>
//                 </Grid>
//               </Grid>
//               <Grid item lg={6} sm={6} xs={12}>
//                 <Button
//                   type="reset"
//                   fullWidth
//                   style={{
//                     backgroundColor: "#F43F5E",
//                     color: "white",
//                     marginTop: "10px",
//                   }}
//                     disabled={isSubmitting}
//                   onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
//                     formik.resetForm();
//                   }}
//                 >
//                   {t("text.reset")}
//                 </Button>
//               </Grid>
//             </Grid>
//             {/* </Card> */}
//           </form>
//         </CardContent>
//       </div>
//     </div>
//   );
// };

// export default CityMasterEdit;



import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  CircularProgress,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import ToastApp from "../../../ToastApp";

type Props = {};

const CityMasterEdit = (props: Props) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const location = useLocation();
  console.log("location", location.state);

  const [option, setOption] = useState([{ value: "-1", label: t("text.SelectStateName") }]);
  let navigate = useNavigate();
  const [toaster, setToaster] = useState(false);

  useEffect(() => {
    getStateZone();
  }, []);

  const getStateZone = () => {
    const collectData = {
      state_id: -1,
      country_id: -1
    };
    axios
      .post(HOST_URL.HOST_URL2 + `State/GetStateMaster`, collectData)
      .then((res) => {
        const arr = [];
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["state_name"],
            value: res.data.data[index]["state_id"],
          });
        }
        setOption(arr);
      });
  };

  // Enhanced validation schema with comprehensive input validation
  const validationSchema = Yup.object({
    state_id: Yup.string()
      .test(
        "required",
        t("text.reqstateName"),
        function (value: any) {
          return value && value.trim() !== "";
        }
      )
      .test(
        "valid-state",
        t("text.invalidStateSelection"),
        function (value: any) {
          return value !== "-1" && value !== "" && value !== null;
        }
      ),
    city_name: Yup.string()
      .test(
        "required",
        t("text.reqdistrictName"),
        function (value: any) {
          return value && value.trim() !== "";
        }
      )
      .max(20, t("text.cityNameMaxLength"))
      .matches(/^[a-zA-Z0-9\s\-\.\(\)\[\]\&\,\']+$/, t("text.invalidCityName"))
      .test(
        "no-special-chars-start-end",
        t("text.noSpecialCharsStartEnd"),
        function (value: any) {
          if (!value) return true;
          return !/^[^a-zA-Z0-9\s]|[^a-zA-Z0-9\s]$/.test(value);
        }
      )
      .test(
        "no-multiple-special-chars",
        t("text.noMultipleSpecialChars"),
        function (value: any) {
          if (!value) return true;
          return !/[^a-zA-Z0-9\s]{2,}/.test(value);
        }
      ),
    city_shortname: Yup.string()
      .max(10, t("text.cityShortNameMaxLength"))
      .matches(/^[a-zA-Z0-9\-\.\(\)]*$/, t("text.invalidShortName"))
      .test(
        "no-special-chars-start-end-short",
        t("text.noSpecialCharsStartEndShort"),
        function (value: any) {
          if (!value) return true;
          return !/^[^a-zA-Z0-9]|[^a-zA-Z0-9]$/.test(value);
        }
      ),
  });

  // Function to sanitize input by removing potentially dangerous characters
  const sanitizeInput = (value: string, fieldName: string) => {
    if (!value) return value;
    
    let sanitized = value;
    
    switch(fieldName) {
      case 'city_name':
        sanitized = value.replace(/[^a-zA-Z0-9\s\-\.\(\)\[\]\&\,\']/g, '');
        sanitized = sanitized.replace(/([^a-zA-Z0-9\s]){2,}/g, '$1');
        sanitized = sanitized.replace(/^[^a-zA-Z0-9\s]+|[^a-zA-Z0-9\s]+$/g, '');
        break;
      case 'city_shortname':
        sanitized = value.replace(/[^a-zA-Z0-9\-\.\(\)]/g, '');
        sanitized = sanitized.replace(/^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g, '');
        break;
      default:
        sanitized = value.replace(/[<>{}[\]\\]/g, '');
    }
    
    return sanitized;
  };

  // Custom onChange handler to sanitize input in real-time
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    const sanitizedValue = sanitizeInput(value, name);
    
    if (value !== sanitizedValue) {
      formik.setFieldValue(name, sanitizedValue);
    } else {
      formik.handleChange(e);
    }
  };

  const formik = useFormik({
    initialValues: {
      city_id: location.state.city_id,
      city_name: location.state.city_name,
      state_id: location.state.state_id,
      city_shortname: location.state.city_shortname,
      stateName: location.state.stateName,
      user_id: location.state.user_id,
      inst_ID: location.state.inst_ID,
      allowedto: location.state.allowedto,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // Additional server-side validation before submission
      const sanitizedValues = {
        ...values,
        city_name: sanitizeInput(values.city_name, 'city_name'),
        city_shortname: sanitizeInput(values.city_shortname, 'city_shortname')
      };
      
      // Clear any existing timeout
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }
      
      // If already submitting, show message and return
      if (isSubmitting) {
        toast.info(t("text.requestInProgress"));
        return;
      }
      
      setIsSubmitting(true);

      try {
        const response = await axios.post(HOST_URL.HOST_URL2 + `District/AddUpdateDistrictMaster`,
          sanitizedValues
        );
        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          navigate("/master/CityMaster");
        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      } catch (error: any) {
        if (error.response && error.response.status === 429) {
          toast.error(t("text.tooManyRequests"));
        } else {
          toast.error(t("text.somethingWentWrong"));
        }
        setToaster(true);
      } finally {
        // Set a timeout to reset isSubmitting after 2 seconds
        submitTimeoutRef.current = setTimeout(() => {
          setIsSubmitting(false);
        }, 2000);
      }
    }
  });

  // Add cleanup effect
  React.useEffect(() => {
    return () => {
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }
    };
  }, []);

  const requiredFields = ["state_id", "city_name"];
  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginTop: "5px",
          border: ".5px solid #FF7722",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.EditDistrictMaster")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="button"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
                disabled={isSubmitting}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            <ToastContainer />
            <Grid item xs={12} container spacing={2}>
              <Grid xs={12} sm={4} item>
                <Autocomplete
                  disablePortal
                  id="state-autocomplete"
                  options={option}
                  fullWidth
                  size="small"
                  disabled={isSubmitting}
                  value={option.find(opt => opt.value === formik.values.state_id) || null}
                  onChange={(event, newValue) => {
                    formik.setFieldValue("state_id", newValue?.value);
                    formik.setFieldTouched("state_id", true);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectStateName")} {""}
                          {requiredFields.includes("state_id") && (
                            <span
                              style={{
                                color: formik.values.state_id
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                      error={formik.touched.state_id && Boolean(formik.errors.state_id)}
                    />
                  )}
                />
                {formik.touched.state_id && formik.errors.state_id ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.state_id)}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  label={
                    <span>
                      {t("text.EnterDistrictName")}{" "}
                      {requiredFields.includes("city_name") && (
                        <span
                          style={{
                            color: formik.values.city_name ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.city_name}
                  name="city_name"
                  id="city_name"
                  placeholder={t("text.EnterDistrictName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={handleInputChange}
                  onBlur={formik.handleBlur}
                  inputProps={{ 
                    maxLength: 20,
                    pattern: "[a-zA-Z0-9\\s\\-\\.\\(\\)\\[\\]\\&\\,\\']*"
                  }}
                  disabled={isSubmitting}
                  error={formik.touched.city_name && Boolean(formik.errors.city_name)}
                />
                {formik.touched.city_name && formik.errors.city_name ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.city_name)}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  id="city_shortname"
                  name="city_shortname"
                  label={t("text.EnterShortName")}
                  value={formik.values.city_shortname}
                  placeholder={t("text.EnterShortName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={handleInputChange}
                  onBlur={formik.handleBlur}
                  inputProps={{ 
                    maxLength: 10,
                    pattern: "[a-zA-Z0-9\\-\\.\\(\\)]*"
                  }}
                  disabled={isSubmitting}
                  error={formik.touched.city_shortname && Boolean(formik.errors.city_shortname)}
                />
                {formik.touched.city_shortname && formik.errors.city_shortname ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.city_shortname)}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: `var(--header-background)`,
                      color: "white",
                      marginTop: "10px",
                    }}
                    disabled={isSubmitting || !formik.isValid}
                    startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
                  >
                    {isSubmitting ? t("text.submitting") : t("text.update")}
                  </Button>
                </Grid>
              </Grid>
              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  disabled={isSubmitting}
                  onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    formik.resetForm();
                  }}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default CityMasterEdit;
